module.exports = __webpack_public_path__ + "img/click.883eec5a.png";